import { Button } from './button';
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip';

function TooltipIconButton({
  label,
  icon: Icon,
  variant = 'outline',
  size = 'icon',
  side = 'top',
  className,
  iconClassName = 'h-4 w-4',
  children,
  asChild = false,
  ...props
}) {
  if (asChild) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          {children}
        </TooltipTrigger>
        <TooltipContent side={side}>{label}</TooltipContent>
      </Tooltip>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant={variant} size={children ? 'default' : size} className={className} {...props}>
          {Icon && <Icon className={iconClassName} />}
          {children}
          {!children && <span className="sr-only">{label}</span>}
        </Button>
      </TooltipTrigger>
      <TooltipContent side={side}>{label}</TooltipContent>
    </Tooltip>
  );
}

export { TooltipIconButton };
